<template>
  <zm-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <zm-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span
          v-if="item.redirect === 'noredirect' || index == levelList.length"
          class="no-redirect"
          >{{ item.name }}</span
        >
        <router-link v-else :to="item.redirect || item.path">{{
          item.name
        }}</router-link>
      </zm-breadcrumb-item>
      <zm-breadcrumb-item
        key="triggerId"
        v-if="levelList[1] && levelList[1].name === 'Triggers'"
      >
        <span>{{ triggerId }}</span>
      </zm-breadcrumb-item>
    </transition-group>
  </zm-breadcrumb>
</template>

<script>
export default {
  created() {
    this.getBreadcrumb()
  },
  data() {
    return {
      levelList: null,
      applicationId: ''
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  methods: {
    getBreadcrumb() {
      var matched = this.$route.matched.filter(item => item.name)
      if (matched.length > 1) {
        if (matched[1].meta.title === 'Secret') {
          this.applicationId = this.$route.params.id
          matched[1].name = 'Application'
          matched[1].path = '/csms/application'
          matched.push({
            name: 'Secret',
            path: '/csms/application/secret/' + this.applicationId
          })
        }
      }
      this.levelList = matched
    }
  }
}
</script>
<style scoped>
.zm-breadcrumb {
  line-height: 1.5;
}
</style>
